import React from "react";
import * as R from "ramda";
import { NavLink, Route, Switch, Redirect, withRouter } from "react-router-dom";
import AdminUserCreate from "components/AdminUserCreate";
import AdminAccessLevelCreate from "components/AdminAccessLevelCreate";
import AdminAccessCardCreate from "components/AdminAccessCardCreate";
import AdminUserList from "components/AdminUserList";
import AdminAccessLevelList from "components/AdminAccessLevelList";
import AdminAccessCardList from "components/AdminAccessCardList";
import AdminReaderList from "components/AdminReaderList";
import AdminReaderCreate from "components/AdminReaderCreate";
import AdminLocationList from "components/AdminLocationList";
import AdminLocationCreate from "components/AdminLocationCreate";
import { logout } from "actions/login";
import { connect } from "react-redux";

const mapDispatchToProps = {
  logout
};

class Admin extends React.Component {
  handleLogout = () => {
    const { logout, history } = this.props;
    logout().then(() => history.push("/login"));
  };

  render() {
    return (
      <React.Fragment>
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
          <a className="navbar-brand">Adgangskort-admin</a>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto" />
            <form className="form-inline my-2 my-lg-0">
              <button
                className="btn btn-outline-danger my-2 my-sm-0"
                onClick={this.props.logout}
              >
                Logg ut
              </button>
            </form>
          </div>
        </nav>

        <div className="card">
          <div className="card-header">
            <ul className="nav nav-tabs card-header-tabs">
              <li className="nav-item">
                <NavLink className="nav-link" to="/admin/location/list">
                  Lokasjoner
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/admin/user/list">
                  Brukere/Bestillere
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/admin/reader/list">
                  Lesere
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/admin/accesslevel/list">
                  Adgangsnivåer
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/admin/accesscard/list">
                  Adgangskort
                </NavLink>
              </li>
            </ul>
          </div>
          <div className="card-body">
            <Switch>
              <Route path="/admin/user/create" component={AdminUserCreate} />
              <Route path="/admin/user/list" component={AdminUserList} />
              <Route
                path="/admin/location/create"
                component={AdminLocationCreate}
              />
              <Route
                path="/admin/location/list"
                component={AdminLocationList}
              />
              <Route
                path="/admin/accesslevel/create"
                component={AdminAccessLevelCreate}
              />
              <Route
                path="/admin/accesslevel/list"
                component={AdminAccessLevelList}
              />
              <Route
                path="/admin/accesscard/list"
                component={AdminAccessCardList}
              />
              <Route
                path="/admin/accesscard/create"
                component={AdminAccessCardCreate}
              />
              <Route path="/admin/reader/list" component={AdminReaderList} />
              <Route
                path="/admin/reader/create"
                component={AdminReaderCreate}
              />
              <Redirect to="/admin/user/list" />
            </Switch>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default R.compose(withRouter, connect(null, mapDispatchToProps))(Admin);



// WEBPACK FOOTER //
// ./src/components/Admin.js